import { sagaMiddleware } from '../../store';
import saga from './saga';
import * as _actions from './actions.js';
import * as _selectors from './selectors.js';

sagaMiddleware.run(saga);

export const actions = _actions;
export const selectors = _selectors;